// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"530efd0c","115":"f876f0b0","335":"530efd0c","716":"92d21c04"}[chunkId] + ".chunk.css";
};